import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { i18n } from "../../translate/i18n";

const EMOJIS = ["👍", "👎", "❤️", "😂", "😮", "😢", "🙏", "🔥", "👏", "😊"];

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(0.5),
    maxWidth: 320,
    borderRadius: 12,
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
  },
  emojiRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  emojiButton: {
    fontSize: 22,
    padding: 6,
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.06)",
    },
  },
  removeRow: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  removeButton: {
    textTransform: "none",
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
}));

const MessageReactionPicker = ({ open, anchorEl, onClose, onSelect, onRemove, existingReactionFromUs }) => {
  const classes = useStyles();

  const handleSelect = (emoji) => {
    onSelect(emoji);
    onClose();
  };

  const handleRemove = () => {
    if (onRemove) onRemove();
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      PaperProps={{
        className: classes.paper,
      }}
    >
      {existingReactionFromUs && onRemove && (
        <>
          <div className={classes.removeRow}>
            <Button
              size="small"
              className={classes.removeButton}
              onClick={handleRemove}
              fullWidth
            >
              {i18n.t("messagesList.removeReaction")} {existingReactionFromUs}
            </Button>
          </div>
          <Divider />
        </>
      )}
      <div className={classes.emojiRow}>
        {EMOJIS.map((emoji) => (
          <IconButton
            key={emoji}
            size="small"
            className={classes.emojiButton}
            onClick={() => handleSelect(emoji)}
            aria-label={`React with ${emoji}`}
          >
            {emoji}
          </IconButton>
        ))}
      </div>
    </Popover>
  );
};

export default MessageReactionPicker;
